import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { bottom, height, left, overflow, position, width } from 'styled-system';
import type {
  BorderColorProps,
  BorderProps,
  BorderRightProps,
  BorderStyleProps,
  BottomProps,
  HeightProps,
  LeftProps,
  OverflowProps,
  PositionProps,
  WidthProps,
} from 'styled-system';

import {
  transform,
  type BorderBottomWidthProps,
  type BorderLeftWidthProps,
  type BorderRightWidthProps,
  type BorderTopColorProps,
  type BorderTopWidthProps,
  type TransformProps,
  type Translate3DProps,
} from 'common/theme/system-utilities';

export const DownArrow = styled.span<
  PositionProps &
    BottomProps &
    LeftProps &
    BorderProps &
    BorderColorProps &
    BorderStyleProps &
    BorderTopColorProps &
    BorderBottomWidthProps &
    BorderRightProps &
    BorderLeftWidthProps &
    BorderTopWidthProps &
    BorderRightWidthProps &
    Translate3DProps &
    TransformProps &
    WidthProps &
    HeightProps &
    OverflowProps & { backgroundColor: string; borderColor: string }
>`
  ${position};
  ${bottom};
  ${left};
  ${transform};
  ${width};
  ${height};
  ${overflow};

  :after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    top: -5px;
    background: ${props => props.backgroundColor};
    border: 1px solid ${props => props.borderColor};
    border-top: none;
    border-left: none;
  }
`;

export const downArrowStyles: Partial<ComponentProps<typeof DownArrow>> = {
  role: 'presentation',
  position: 'absolute',
  left: '50%',
  bottom: '-18px',
  transform: 'translateX(-50%)',
  width: '24px',
  height: '20px',
};
